var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auto-complete',{attrs:{"placeholder":"Buscar por ubicación. Ejm: Miraflores","type":_vm.type,"rows":2,"fetch-suggestions":_vm.getLocations,"value-key":"name","size":_vm.size,"cache":false},on:{"select":_vm.selectLocation}})}
var staticRenderFns = []

export { render, staticRenderFns }